import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import DoneIcon from "@material-ui/icons/Done";
import ClearIcon from "@material-ui/icons/Clear";

const styles = (theme) => ({
  footerButtonView: {
    justifyContent: "center",
    marginTop: 20,
    marginBottom: 20,
  },
  clearButton: {
    marginRight: 20,
    color: "white",
    padding: 10,
    minWidth: 40,
    minheight: 40,
  },
  doneButton: {
    marginLeft: 20,
    color: "white",
    backgroundColor: "#F29A3E",
    padding: 10,
    minWidth: 40,
    minheight: 40,
  },
});

function MultiButton(props) {
  const { classes, resetButton, saveButton, disableButton } = props;

  return (
    <div>
      <Grid container xs={12} className={classes.footerButtonView}>
        <Button
          onClick={resetButton}
          variant="contained"
          size="large"
          color="primary"
          className={classes.clearButton}
        >
          <ClearIcon fontSize="large" />
        </Button>
        <Button
          onClick={saveButton}
          variant="contained"
          size="large"
          disabled={disableButton}
          className={classes.doneButton}
        >
          <DoneIcon fontSize="large" />
        </Button>
      </Grid>
    </div>
  );
}

export default withStyles(styles)(MultiButton);
